<topo-dialog
  [dialogRef]="dialogRef"
  hideHeaderClose>
  <label>{{ 'MANAGEMENT.COMMUNICATION-CENTER.TEMPLATE-GROUP-EDIT' | translate }}</label>
  <topo-template-group-crud-input
    [state]="data.state"
    [initialValue]="data.templateGroup.name"
    (onSubmit)="dialogRef.close($event)"
    (onClear)="dialogRef.close()" />
</topo-dialog>
